









import { Component, Vue } from 'vue-property-decorator';
import BulkUpdateRequest from '@/models/BulkUpdateRequest';
import { mapState } from 'vuex';
import moment from 'moment';

@Component({
  computed: mapState({
    dropdown: (state: any) => state.dashboard.dropdownRoomStatus,
  }),
})
export default class DropdownRoomStatus extends Vue {
  private created() {
    window.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        this.$dropdown.hide();
      }
    });
  }

  private destroyed() {
    window.removeEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        this.$dropdown.hide();
      }
    });
  }
}
